<p-dialog
  header="Share via Email"
  [(visible)]="visible"
  [modal]="true"
  [appendTo]="'body'"
  [style]="{ width: '28rem' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onDialogHide()"
>
  <h4 class="mb-3 mt-0">Job: {{ context.jobTitle ?? context.position_title ?? 'N/A' }}</h4>
   
  <div class="flex flex-column gap-2">
    <label for="share-email-input" class="formL-1">Recipient Email</label>
    <input
      pInputText
      id="share-email-input"
      type="email"
      class="w-full"
      [(ngModel)]="email"
      autocomplete="email"
    />
    @if (emailInvalid) {
      <small class="p-error" style="color: rgb(231, 12, 12);">Enter a valid email address.</small>
    }
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancel" severity="secondary" (click)="onCancel()"></button>
    <button pButton type="button" label="Send" (click)="onSend()"></button>
  </ng-template>
</p-dialog>
